var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowTender)?_c('div',[_c('PosTender',{attrs:{"summaryProp":_vm.summary,"orderItemsProp":_vm.orderItems},on:{"addItem":_vm.addItem,"showTender":_vm.showTender}})],1):_c('div',[_c('PosSaleReceipt',{attrs:{"summaryProp":_vm.summary,"orderItemsProp":_vm.orderItems},on:{"addItem":_vm.addItem,"showTender":_vm.showTender}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }